/* ============================================================
   Giver — Self-contained cart drawer controller
   Owns add / quantity / remove / render via Shopify Cart API
   (/cart.js, /cart/add.js, /cart/change.js). Opens the theme's
   slide drawer (html.cart-show). Intercepts EVERY add-to-cart
   trigger site-wide (home "Shop Now" links, /cart permalinks,
   product & combo page add buttons/forms, drawer cross-sell)
   so nothing depends on the theme's own ajax cart.
   Renders into the existing #dropdown-cart markup using the
   classes giver-cart.css already styles.
   ============================================================ */
(function () {
  if (window.__giverCartV2) return; window.__giverCartV2 = true;

  var DROP = '#dropdown-cart';

  var CFG = {
    bogoProductIds: [8874154197163, 8874162913451, 8372788232363, 8899646128299],
    upsellProductId: 6696927854763, // UltraBrain
    combos: {
      '8373054570667': ['UltraBrain™ · 42 caps', 'Brainstaq™ · 30 caps', 'BluBrain™ · 60 caps'],
      '7100274901163': ['UltraBrain™ · 42 caps', 'Brainstaq™ · 30 caps'],
      '7097932480683': ['Brainstaq™ · 30 caps', 'TrueSleep™'],
      '7097953058987': ['UltraBrain™ · 42 caps', 'TrueSleep™']
    },
    // Cross-sell is built LIVE from /products.json (in-stock only, cart-aware).
    // Exclude promo/BOGO landing SKUs and non-catalog items from the upsell:
    crossSellExclude: /(?:buy\s*\d|get\s*1\s*free|bogo|back\s*up|backup|\btest\b|gift\s*card|do\s*not|niqox)/i,
    // Nicer display names for known products (others use their catalog title):
    titleMap: { '7100274901163': 'UltraBrain™ + Brainstaq™', '8373054570667': 'Focus Stack ×3' },
    crossSellMax: 12,
    coupon: true,
    freeGift: null,   // { threshold: 2499, name: 'Free Shaker' }
    prepaid: null,    // 'Save up to ₹50 on prepaid'
    // Per-product tagline under the name. PLACEHOLDERS — replace with final copy.
    taglines: {
      '6696927854763': 'Sharper focus, every day',                    // UltraBrain (best seller)
      '6817494728875': "Lion's Mane + Ginkgo · instant clarity",       // Brainstaq
      '8874154197163': "Lion's Mane + Ginkgo · instant clarity",       // Brainstaq BOGO
      '8874162913451': "Lion's Mane + Ginkgo · instant clarity",
      '8372788232363': "Lion's Mane + Ginkgo · instant clarity",
      '8899646128299': "Lion's Mane + Ginkgo · instant clarity",
      '7100274901163': 'Your daily + instant duo',                     // UB + Brainstaq
      '8373054570667': 'The complete brain stack',                     // 3-stack
      '7097932480683': 'Focus by day, calm by night',                 // Brainstaq + TrueSleep
      '7097953058987': 'Focus by day, calm by night'                  // UB + TrueSleep
    },
    taglineFallback: 'Premium cognitive support',
    reassure: [
      { svg: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="4" y="10" width="16" height="10" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg>', t: '100% secure payment' },
      { svg: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 7h11v8H3zM14 10h4l3 3v2h-7z"/><circle cx="7.5" cy="17" r="1.5"/><circle cx="17" cy="17" r="1.5"/></svg>', t: 'Fast delivery across India' },
      { svg: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2s7 3 7 10a7 7 0 0 1-14 0c0-2 1-4 2-5"/><path d="M12 22V12"/></svg>', t: 'FSSAI-certified · plant-based' }
    ]
  };

  function q(s, r) { return (r || document).querySelector(s); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(paise) { return '₹' + Math.round((paise || 0) / 100).toLocaleString('en-IN'); }
  function drop() { return q(DROP); }

  function getJSON(url) { return fetch(url, { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().catch(function () { return {}; }); });
  }

  function openDrawer() { document.documentElement.classList.add('cart-show'); }

  // ---------------- rendering ----------------
  function giftIcon() {
    return '<span class="gv-ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M5 12v9h14v-9M12 8v13M12 8S9 3 6 5s6 3 6 3zM12 8s3-5 6-3-6 3-6 3z"/></svg></span>';
  }

  function itemHTML(it) {
    var pid = it.product_id;
    var variant = (it.variant_title && it.variant_title.indexOf('Default') === -1) ? it.variant_title : '';
    var bogo = '';
    if (CFG.bogoProductIds.indexOf(pid) !== -1) {
      bogo = '<div class="gv-bogo">' + giftIcon() + '<span class="gv-tx">Buy 1 Get 1 Free<small>Your free bottle is included ✓</small></span></div>';
    } else if (pid === 6817494728875 && it.quantity >= 2) {
      bogo = '<div class="gv-bogo">' + giftIcon() + '<span class="gv-tx">2nd bottle free<small>Auto-applied · you save ₹1,049</small></span></div>';
    }
    var combo = '';
    var c = CFG.combos[String(pid)];
    if (c) {
      combo = '<details class="gv-inside"><summary>What’s inside · ' + c.length + ' items <svg class="gv-chev" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 9l6 6 6-6"/></svg></summary><div class="gv-inbox">' +
        c.map(function (x) { return '<div class="gv-inrow"><span class="gv-dot"></span>' + esc(x) + ' <b>Included</b></div>'; }).join('') + '</div></details>';
    }
    var upsell = (pid === CFG.upsellProductId) ? '<button type="button" class="gv-upsell">＋ Add another</button>' : '';
    var tag = CFG.taglines[String(pid)] || CFG.taglineFallback;
    var img = it.image ? it.image.replace(/(\.[a-zA-Z]+)(\?|$)/, '_160x$1$2') : '';
    return '<li class="item" data-key="' + esc(it.key) + '" data-product-id="' + pid + '">' +
      '<a href="' + it.url + '" class="product-image"><img src="' + img + '" alt="' + esc(it.product_title) + '"></a>' +
      '<div class="product-details">' +
      '<a class="product-name" href="' + it.url + '">' + esc(it.product_title) + '</a>' +
      (tag ? '<div class="gv-tag">' + esc(tag) + '</div>' : '') +
      '<div class="option">' + (variant ? '<small>' + esc(variant) + '</small>' : '') + '</div>' +
      bogo + combo + upsell +
      '<div class="cart-collateral"><span class="price">' + money(it.final_line_price) + '</span></div>' +
      '<div class="quantity"><button type="button" class="gv-step minus" aria-label="Decrease">−</button>' +
      '<input class="item-quantity" value="' + it.quantity + '" readonly>' +
      '<button type="button" class="gv-step plus" aria-label="Increase">+</button></div>' +
      '</div>' +
      '<a href="javascript:void(0)" class="btn-remove" aria-label="Remove"></a>' +
      '</li>';
  }

  function renderReward(cart) {
    var has = q('.has-items', drop()); if (!has) return;
    var m = q('.gv-reward', has);
    if (!m) { m = document.createElement('div'); m.className = 'gv-reward'; has.insertBefore(m, has.firstChild); }
    var spent = cart.total_price / 100;
    var t1 = Number(window.free_shipping_price) || 0;
    var tiers = [];
    if (t1 > 0) tiers.push({ v: t1, label: 'Free shipping', icon: '🚚' });
    if (CFG.freeGift && CFG.freeGift.threshold > 0) tiers.push({ v: CFG.freeGift.threshold, label: CFG.freeGift.name || 'Free gift', icon: '🎁' });
    if (!tiers.length) { m.style.display = 'none'; return; }
    m.style.display = '';
    var max = tiers[tiers.length - 1].v, pct = Math.max(0, Math.min(100, Math.round(spent / max * 100)));
    var next = null; for (var i = 0; i < tiers.length; i++) { if (spent < tiers[i].v) { next = tiers[i]; break; } }
    var msg = next ? ('Add <b>₹' + Math.ceil(next.v - spent).toLocaleString('en-IN') + '</b> to unlock <b>' + esc(next.label) + '</b>') : '<b>You’ve unlocked all rewards ✓</b>';
    var leg = tiers.length > 1 ? '<div class="gv-rw-legend">' + tiers.map(function (t) { var on = spent >= t.v; return '<span class="gv-lg' + (on ? ' on' : '') + '">' + t.icon + ' ' + esc(t.label) + (on ? ' ✓' : '') + '</span>'; }).join('') + '</div>' : '';
    m.innerHTML = '<div class="gv-rw-msg">' + msg + '</div><div class="gv-rw-track"><span style="width:' + pct + '%"></span></div>' + leg;
  }

  function renderCrossSell(cart) {
    var m = q('.gv-xsell', drop()); if (!m) return;
    var inCart = {}; cart.items.forEach(function (i) { inCart[i.product_id] = 1; });
    var list = XSELL.filter(function (x) { return !inCart[x.pid]; }).slice(0, CFG.crossSellMax || 12);
    if (!list.length) { m.style.display = 'none'; m.innerHTML = ''; return; }
    m.style.display = '';
    var cards = list.map(function (x) {
      return '<div class="gv-xcard">' +
        '<a class="gv-xt" href="' + x.url + '"><img src="' + x.img + '" alt="' + esc(x.title) + '" loading="lazy"></a>' +
        '<div class="gv-xb"><a class="gv-xn" href="' + x.url + '">' + esc(x.title) + '</a>' +
        '<div class="gv-xp">' + x.price + '</div>' +
        '<button type="button" class="gv-xadd" data-gv-add="' + x.vid + '">＋ Add</button></div></div>';
    }).join('');
    var arrows = list.length > 2;
    m.innerHTML = '<div class="gv-xh">Complete your stack</div>' +
      '<div class="gv-xwrap' + (arrows ? '' : ' no-arrows') + '">' +
      (arrows ? '<button type="button" class="gv-xarrow left" aria-label="Previous"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg></button>' : '') +
      '<div class="gv-xscroll">' + cards + '</div>' +
      (arrows ? '<button type="button" class="gv-xarrow right" aria-label="Next"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg></button>' : '') +
      '</div>';
  }

  function renderCheckout() {
    var btn = q('.actions .btn-checkout', drop());
    if (btn && !btn.getAttribute('data-gv')) {
      btn.setAttribute('data-gv', '1');
      btn.onclick = null; btn.removeAttribute('onclick'); // we control checkout nav (to carry coupon)
      btn.innerHTML = '<svg class="gv-lock" viewBox="0 0 24 24" fill="#ffffff" aria-hidden="true"><path d="M12 1a5 5 0 0 0-5 5v3H6a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2h-1V6a5 5 0 0 0-5-5zm3 8H9V6a3 3 0 0 1 6 0v3z"/></svg><span class="gv-ck-txt">Secure Checkout</span>';
    }
  }

  function renderReassure() {
    var actions = q('.actions', drop()); if (!actions) return;
    var el = q('.gv-reassure', actions);
    if (!el) { el = document.createElement('div'); el.className = 'gv-reassure'; actions.appendChild(el); }
    if (el.getAttribute('data-gv')) return; el.setAttribute('data-gv', '1');
    var msgs = CFG.reassure || []; if (!msgs.length) return;
    var i = 0;
    function put(k) { el.innerHTML = '<span class="gv-re-ic">' + msgs[k].svg + '</span>' + esc(msgs[k].t); }
    put(0);
    setInterval(function () {
      el.style.opacity = '0';
      setTimeout(function () { i = (i + 1) % msgs.length; put(i); el.style.opacity = '1'; }, 260);
    }, 2600);
  }

  // Coupon is stored the SAME way the old cart did — localStorage 'storedDiscount'
  // + a hidden input[name="discount"] — because Razorpay Magic Checkout reads those
  // to apply the discount to the amount it charges.
  var gvCoupon = null;
  try { gvCoupon = localStorage.getItem('storedDiscount') || null; } catch (e) {}
  var gvCouponMsg = '';      // inline error/status shown under the coupon field
  var gvCouponBusy = false;  // true while an apply/remove request is in flight

  // Razorpay Magic Checkout applies the coupon by reading input[name="discount"]
  // from the page (this is what the old cart's plus_cart_discount_code snippet
  // provided). The input must EXIST in the initial HTML so Magic sees it — the
  // drawer markup now server-renders it; here we only keep its value in sync.
  function syncDiscountInput() {
    var inp = document.querySelector('input[name="discount"]');
    if (!inp) {
      inp = document.createElement('input');
      inp.type = 'hidden'; inp.name = 'discount'; inp.id = 'gv-discount-input';
      inp.setAttribute('autocomplete', 'off');
      (drop() || document.body).appendChild(inp);
    }
    inp.value = gvCoupon || '';
  }

  function couponInner() {
    if (gvCoupon) {
      return '<div class="gv-coupon-applied"><span class="gv-cok"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12l5 5L20 6"/></svg><b>' + esc(gvCoupon) + '</b> applied</span>' +
        '<button type="button" class="gv-coupon-remove">Remove</button></div>';
    }
    return '<button type="button" class="gv-coupon-toggle"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="margin-right:6px;vertical-align:-2px"><path d="M20.6 13.4 11 3.8A2 2 0 0 0 9.6 3H4v5.6a2 2 0 0 0 .6 1.4l9.6 9.6a2 2 0 0 0 2.8 0l3.6-3.6a2 2 0 0 0 0-2.8z"/><circle cx="7.5" cy="7.5" r="1.2" fill="currentColor"/></svg>Have a discount code?</button>' +
      '<div class="gv-coupon-row"><input type="text" class="gv-coupon-in" placeholder="Enter code" autocomplete="off"' + (gvCouponBusy ? ' disabled' : '') + '><button type="button" class="gv-coupon-btn"' + (gvCouponBusy ? ' disabled' : '') + '>' + (gvCouponBusy ? 'Applying…' : 'Apply') + '</button></div>' +
      (gvCouponMsg ? '<div class="gv-cerr">' + esc(gvCouponMsg) + '</div>' : '');
  }
  function renderCoupon() {
    if (!CFG.coupon) return;
    var summary = q('.summary', drop()); if (!summary) return;
    var c = q('.gv-coupon', summary);
    if (!c) { c = document.createElement('div'); c.className = 'gv-coupon'; summary.insertBefore(c, summary.firstChild); }
    c.className = 'gv-coupon' + (gvCoupon ? '' : ' collapsed');
    c.innerHTML = couponInner();
  }

  // Is `code` present on the cart AND actually applicable to it?
  function codeApplicable(cart, code) {
    var lc = String(code || '').toLowerCase();
    return (cart && cart.discount_codes || []).some(function (d) {
      return String(d.code).toLowerCase() === lc && d.applicable;
    });
  }

  // Apply / remove a coupon by pushing it to the Shopify cart itself (Cart AJAX API,
  // /cart/update.js discount param). This makes the drawer total reflect the discount
  // immediately AND validates the code against Shopify. We also mirror the code into
  // localStorage 'storedDiscount' + input[name="discount"] so Razorpay Magic Checkout
  // charges the same discounted amount at payment.
  function setCoupon(code) {
    code = (code || '').trim();
    gvCouponMsg = '';
    if (!code) {                 // ---- remove ----
      gvCoupon = null;
      try { localStorage.removeItem('storedDiscount'); } catch (e) {}
      syncDiscountInput();
      gvCouponBusy = true; renderCoupon();
      postJSON('/cart/update.js', { discount: '' }).then(function (cart) {
        gvCouponBusy = false;
        if (cart && cart.items) render(cart); else refresh();
      }).catch(function () { gvCouponBusy = false; refresh(); });
      return;
    }
    // ---- apply ----
    gvCouponBusy = true; renderCoupon();
    postJSON('/cart/update.js', { discount: code }).then(function (cart) {
      gvCouponBusy = false;
      if (cart && codeApplicable(cart, code)) {
        gvCoupon = code;
        try { localStorage.setItem('storedDiscount', code); } catch (e) {}
        syncDiscountInput();
        render(cart);            // shows the discounted total + "applied" chip
      } else {
        // Shopify rejected it (invalid / expired / not eligible for these items)
        gvCoupon = null;
        try { localStorage.removeItem('storedDiscount'); } catch (e) {}
        syncDiscountInput();
        gvCouponMsg = 'That code isn’t valid for the items in your cart.';
        if (cart && cart.items) render(cart); else refresh();
      }
    }).catch(function () {
      gvCouponBusy = false; gvCouponMsg = 'Could not apply the code. Please try again.';
      renderCoupon();
    });
  }
  function goCheckout() {
    // The discount already lives on the Shopify cart (for display) and in
    // input[name="discount"] / localStorage (for Razorpay Magic). Just go to checkout.
    syncDiscountInput();
    window.location.href = '/checkout';
  }

  function trustHTML() {
    return '<span class="gv-titem hl"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12l5 5L20 6"/></svg>BOGO applied</span>' +
      '<span class="gv-sep"></span><span class="gv-titem"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="4" y="10" width="16" height="10" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg>Secure</span>' +
      '<span class="gv-sep"></span><span class="gv-titem">FSSAI certified</span>';
  }
  function renderTrust() {
    var actions = q('.actions', drop()); if (!actions || q('.gv-trustfoot', actions)) return;
    var el = document.createElement('div'); el.className = 'gv-trustfoot'; el.innerHTML = trustHTML();
    actions.insertBefore(el, actions.firstChild);
  }
  function renderPay() {
    var actions = q('.actions', drop()); if (!actions || q('.gv-pay', actions)) return;
    var p = document.createElement('div'); p.className = 'gv-pay';
    p.innerHTML = '🔒 Secure checkout <span class="gv-b"><span>VISA</span><span>UPI</span><span>RUPAY</span></span>';
    actions.appendChild(p);
  }

  function updateFigures(cart) {
    var summary = q('.summary', drop()); if (!summary) return;
    var figs = q('.gv-figs', summary);
    if (!figs) { figs = document.createElement('div'); figs.className = 'gv-figs'; var total = q('.total', summary); if (total) summary.insertBefore(figs, total); else summary.appendChild(figs); }
    var orig = (cart.original_total_price != null) ? cart.original_total_price : cart.total_price;
    var save = orig - cart.total_price, pct = orig > 0 ? Math.round(save / orig * 100) : 0;
    var html = '<div class="gv-l"><span>Subtotal</span><span class="v">' + money(orig) + '</span></div>';
    if (save > 0) html += '<div class="gv-savebar">You save ' + money(save) + ' <b>(' + pct + '% off)</b></div>';
    if (CFG.prepaid) html += '<div class="gv-l prepaid"><span>' + esc(CFG.prepaid) + '</span><span class="v"></span></div>';
    figs.innerHTML = html;
    // theme total + discount chip
    var tp = q('.summary .total .price', drop()); if (tp) tp.textContent = money(cart.total_price);
    var lbl = q('.summary .total .label span', drop()); if (lbl) lbl.textContent = 'Total (' + cart.item_count + (cart.item_count === 1 ? ' item)' : ' items)');
    var dw = q('[data-cart-discount-wrapper]', drop());
    if (dw) {
      var d = (cart.cart_level_discount_applications || [])[0];
      if (d) { dw.style.display = ''; var dt = q('[data-cart-discount-title]', dw); if (dt) dt.textContent = d.title; var da = q('[data-cart-discount-amount]', dw); if (da) da.textContent = money(d.total_allocated_amount); }
      else dw.style.display = 'none';
    }
  }

  function setCount(cart) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cart-count], .cartCount'), function (n) { n.textContent = cart.item_count; });
    var wc = q('.wrapper-cartCount', drop()); if (wc) wc.style.display = cart.item_count > 0 ? '' : 'none';
  }

  // Keep gvCoupon in sync with whatever discount code the Shopify cart actually holds.
  // The cart is the source of truth: if the code is applied+applicable, adopt it and
  // mirror to localStorage/input for Magic; if the cart has no applicable code, drop it.
  function syncCouponFromCart(cart) {
    var applied = (cart && cart.discount_codes || []).filter(function (d) { return d.applicable; })[0];
    var code = applied ? applied.code : null;
    if (code !== gvCoupon) {
      gvCoupon = code;
      try { if (code) localStorage.setItem('storedDiscount', code); else localStorage.removeItem('storedDiscount'); } catch (e) {}
    }
    syncDiscountInput();
  }

  function render(cart) {
    var d = drop(); if (!d) return;
    if (!gvCouponBusy) syncCouponFromCart(cart);
    setCount(cart);
    var has = q('.has-items', d), no = q('.no-items', d);
    if (cart.item_count === 0) { if (has) has.style.display = 'none'; if (no) no.style.display = ''; renderCrossSell(cart); return; }
    if (has) has.style.display = ''; if (no) no.style.display = 'none';
    var ol = q('.mini-products-list', d);
    if (ol) ol.innerHTML = cart.items.map(itemHTML).join('');
    renderReward(cart);
    renderCoupon();
    updateFigures(cart);
    renderCrossSell(cart);
    renderCheckout();
    renderReassure();
  }

  var pending = false;
  function refresh() { if (pending) return; pending = true; getJSON('/cart.js').then(function (c) { pending = false; render(c); }).catch(function () { pending = false; }); }

  // Build the cross-sell pool LIVE from the catalog: all published, in-stock
  // singles + combos (promo/BOGO landing SKUs excluded). Runs once, then re-renders.
  var XSELL = [];
  var xsellLoaded = false;
  function loadCrossSell() {
    if (xsellLoaded) return; xsellLoaded = true;
    getJSON('/products.json?limit=250').then(function (d) {
      var prods = (d && d.products) || [];
      var out = [];
      prods.forEach(function (p) {
        if (CFG.crossSellExclude && CFG.crossSellExclude.test(p.title)) return;
        var v = (p.variants || []).filter(function (vv) { return vv.available; })[0]; // first in-stock variant
        if (!v) return;                                                              // out of stock → skip
        var img = (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '';
        out.push({
          vid: v.id, pid: p.id,
          title: CFG.titleMap[String(p.id)] || p.title,
          price: '₹' + Math.round(parseFloat(v.price)).toLocaleString('en-IN'),
          url: '/products/' + p.handle, img: img
        });
      });
      XSELL = out;
      getJSON('/cart.js').then(render).catch(function () {});
    }).catch(function () {});
  }

  // ---------------- mutations ----------------
  function addToCart(id, qty) {
    return postJSON('/cart/add.js', { id: id, quantity: qty || 1 }).then(function () { openDrawer(); refresh(); });
  }
  function changeQty(key, qty) {
    return postJSON('/cart/change.js', { id: key, quantity: qty }).then(function (cart) { if (cart && cart.items) render(cart); else refresh(); });
  }

  // ---------------- drawer interactions ----------------
  function bindDrawer() {
    var d = drop(); if (!d || d.__gvBound) return; d.__gvBound = true;
    d.addEventListener('click', function (e) {
      var t = e.target;
      var arr = t.closest && t.closest('.gv-xarrow');
      if (arr) { var sc = arr.parentNode.querySelector('.gv-xscroll'); if (sc) sc.scrollBy({ left: arr.classList.contains('left') ? -304 : 304, behavior: 'smooth' }); return; }
      var step = t.closest && t.closest('.gv-step');
      if (step) { var li = step.closest('.item'); var inp = q('.item-quantity', li); var cur = parseInt(inp.value, 10) || 1; changeQty(li.getAttribute('data-key'), Math.max(0, cur + (step.classList.contains('plus') ? 1 : -1))); return; }
      var rm = t.closest && t.closest('.btn-remove');
      if (rm) { e.preventDefault(); var li2 = rm.closest('.item'); if (li2) changeQty(li2.getAttribute('data-key'), 0); return; }
      var up = t.closest && t.closest('.gv-upsell');
      if (up) { var li3 = up.closest('.item'); var inp3 = q('.item-quantity', li3); changeQty(li3.getAttribute('data-key'), (parseInt(inp3.value, 10) || 1) + 1); return; }
      var add = t.closest && t.closest('[data-gv-add]');
      if (add) { e.preventDefault(); addToCart(parseInt(add.getAttribute('data-gv-add'), 10), 1); return; }
      var ck = t.closest && t.closest('.btn-checkout');
      if (ck) { e.preventDefault(); e.stopPropagation(); goCheckout(); return; }
      var ct = t.closest && t.closest('.gv-coupon-toggle');
      if (ct) { var wrap = ct.closest('.gv-coupon'); if (wrap) { wrap.classList.remove('collapsed'); var ci = q('.gv-coupon-in', wrap); if (ci) ci.focus(); } return; }
      var cb = t.closest && t.closest('.gv-coupon-btn');
      if (cb) { var ci2 = q('.gv-coupon-in', cb.closest('.gv-coupon')); if (ci2) setCoupon(ci2.value); return; }
      var crm = t.closest && t.closest('.gv-coupon-remove');
      if (crm) { setCoupon(null); return; }
    });
    d.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.keyCode === 13) && e.target.classList && e.target.classList.contains('gv-coupon-in')) {
        e.preventDefault(); setCoupon(e.target.value);
      }
    });
  }

  // ---------------- site-wide add interception ----------------
  function formData(form) {
    if (!form) return null;
    var idEl = form.querySelector('[name="id"]');
    if (!idEl) return null;
    var id = parseInt(idEl.value, 10); if (!id) return null;
    var qEl = form.querySelector('[name="quantity"]');
    var qty = qEl ? (parseInt(qEl.value, 10) || 1) : 1;
    return { id: id, qty: qty };
  }

  function interceptClicks(e) {
    // Giver-offers Brainstaq PDP "Add 2 · Pay for 1" → route through controller, open drawer (no /cart redirect)
    var gvr = e.target.closest && e.target.closest('#gvr-bogo-btn');
    if (gvr) { e.preventDefault(); e.stopPropagation(); addToCart(41531717124267, 2); return; }
    var el = e.target.closest && e.target.closest('a[href], [data-btn-addToCart], [data-express-addtocart], button[name="add"], .add-to-cart-btn, [data-add-to-cart]');
    if (!el) return;

    // (1) add-to-cart LINKS (home "Shop Now": /cart/add?id=.. or /cart/VARIANT:QTY permalinks)
    if (el.tagName === 'A') {
      var href = el.getAttribute('href') || '';
      if (location.pathname.indexOf('/cart') === 0) return; // on cart page, leave links alone
      var m, id, qty = 1;
      if (/\/cart\/add\b/i.test(href) && (m = href.match(/[?&]id=(\d+)/))) { id = parseInt(m[1], 10); var qm = href.match(/[?&]quantity=(\d+)/); if (qm) qty = parseInt(qm[1], 10); }
      else if ((m = href.match(/\/cart\/(\d+):(\d+)\b/))) { id = parseInt(m[1], 10); qty = parseInt(m[2], 10) || 1; }
      else return;
      if (!id) return;
      e.preventDefault(); e.stopPropagation();
      addToCart(id, qty);
      return;
    }

    // (2) add-to-cart BUTTONS (product / combo / grid). Find the form.
    var form = null;
    var fid = el.getAttribute && (el.getAttribute('data-form-id') || el.getAttribute('data-form'));
    if (fid) { try { form = document.querySelector(fid); } catch (x) { form = null; } }
    if (!form) form = el.closest('form');
    if (!form) { var pi = el.closest('.product-item, .col-options'); if (pi) form = pi.querySelector('form'); }
    var data = formData(form);
    if (!data) return; // not a resolvable add — let it be
    if (form && (form.getAttribute('action') || '').indexOf('/cart') === -1 && !el.hasAttribute('data-btn-addToCart') && !el.hasAttribute('data-express-addtocart')) return;
    e.preventDefault(); e.stopPropagation();
    addToCart(data.id, data.qty);
  }

  function interceptSubmit(e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    if (location.pathname.indexOf('/cart') === 0) return;
    var data = formData(form);
    if (!data) return;
    e.preventDefault(); e.stopPropagation();
    addToCart(data.id, data.qty);
  }

  function boot() {
    bindDrawer();
    document.addEventListener('click', interceptClicks, true);
    document.addEventListener('submit', interceptSubmit, true);
    syncDiscountInput();
    refresh();
    loadCrossSell();
    // belt-and-suspenders: keep the theme's old add-to-cart popup hidden (esp. on mobile)
    var pop = document.querySelector('[data-ajax-cart-success]');
    if (pop) { try { var mo = new MutationObserver(function () { if (pop.style.display !== 'none') pop.style.display = 'none'; }); mo.observe(pop, { attributes: true, attributeFilter: ['style', 'class'] }); } catch (e) {} pop.style.display = 'none'; }
    // keep count/drawer in sync if anything else changes the cart
    if (window.jQuery) window.jQuery(document).ajaxComplete(function (ev, xhr, s) { var u = (s && s.url) || ''; if (u.indexOf('/cart/add') !== -1) openDrawer(); if (u.indexOf('/cart') !== -1) refresh(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
